// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-list-item[data-v-7515c42e]{border-bottom:1px solid rgba(0,0,0,.08)}.v-list-item[data-v-7515c42e]:last-child{border-bottom:none}.v-list-item[data-v-7515c42e]:hover{background-color:rgba(0,0,0,.02)}.theme--dark .v-list-item[data-v-7515c42e]{border-bottom-color:rgba(255,255,255,.08)}.theme--dark .v-list-item[data-v-7515c42e]:hover{background-color:rgba(255,255,255,.05)}", ""]);
// Exports
module.exports = exports;
